import { BaseApiService } from './BaseApiService';
import { pauseSensitiveCapture } from '../utils/fullstory';

export interface ApiKey {
  id: number;
  name: string;
  secret_version: number;
  created_at: string;
  issued_at: string;
  expires_at: string;
  last_used_at: string | null;
  status: 'active' | 'expired' | 'revoked';
}
export interface ApiRequestLog {
  id: number;
  request_id: string;
  created_at: string;
  key_id: number | null;
  key_name: string | null;
  secret_version: number | null;
  ip_address: string;
  method: string;
  url: string;
  route: string | null;
  parameters: string;
  headers: string;
  status: number;
  duration_ms: number;
  response_bytes: number | null;
  result_count: number | null;
  outcome: string;
  error_code: string | null;
}
export interface RequestFilters {
  keyId?: string;
  ip?: string;
  endpoint?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}
interface Reply<T> {
  success: boolean;
  data: T;
}
class ApiKeyService extends BaseApiService {
  private async secretRequest(endpoint: string, data: object) {
    const resumeCapture = pauseSensitiveCapture();
    try {
      return await this.post<Reply<{ secret: string; name: string; expires_at: string }>>(
        endpoint,
        data
      );
    } finally {
      resumeCapture();
    }
  }
  list() {
    return this.get<Reply<ApiKey[]>>('/admin/api-keys');
  }
  create(name: string, validDays: number) {
    return this.secretRequest('/admin/api-keys', { name, validDays });
  }
  rotate(id: number, validDays: number) {
    return this.secretRequest(`/admin/api-keys/${id}/rotate`, { validDays });
  }
  revoke(id: number) {
    return this.post<Reply<{ id: number }>>(`/admin/api-keys/${id}/revoke`);
  }
  requests(filters: RequestFilters, page = 1) {
    return this.get<Reply<ApiRequestLog[]> & { pagination: { hasMore: boolean } }>(
      '/admin/api-keys/requests',
      { ...filters, page, pageSize: 50 }
    );
  }
}
export const apiKeyService = new ApiKeyService();
